import type { RouteDefinition } from "../RouteDefinition";
import { createRouteDefintion } from "../RouteDefinition";
import { routeParam, routeTemplate, type RouteTemplate } from "../RouteTemplate";
import type { UnknownQueryParam } from "../query/QueryStringParam";
export type LegacyRoute<RouteParams, QueryParams extends UnknownQueryParam[]> = RouteDefinition<RouteParams, QueryParams>;
export function createLegacySystemOrMixedScopeRoute<RouteParams, QueryParams extends UnknownQueryParam[]>(routeTemplate: RouteTemplate<RouteParams>, queryParameters: [
    ...QueryParams
]): LegacyRoute<RouteParams, QueryParams> {
    return createRouteDefintion({
        absoluteTemplate: routeTemplate,
        relativeTemplate: routeTemplate,
        queryParameters,
    });
}
export function createLegacySpaceRoute<RouteParams, QueryParams extends UnknownQueryParam[]>(relativeRouteTemplate: RouteTemplate<RouteParams>, queryParameters: [
    ...QueryParams
]): LegacyRoute<RouteParams & {
    spaceId: string;
}, QueryParams> {
    return createRouteDefintion({
        absoluteTemplate: routeTemplate `/${routeParam("spaceId")}${relativeRouteTemplate}`,
        relativeTemplate: relativeRouteTemplate,
        queryParameters,
    });
}
